<template>
    <ul :style="{ paddingLeft: paddingLeft }">
        <slot>
            <li v-for="(item, index) in items" :key="index" v-html="item"></li>
        </slot>
    </ul>
</template>

<script lang="ts" setup>
import { defineProps } from 'vue';

interface Props {
    items?: string[];
    paddingLeft?: string;
}

withDefaults(defineProps<Props>(), {
    items: () => [],
    paddingLeft: '20px',
});
</script>

<style scoped lang="scss">
ul {
  list-style-type: disc;
}

li {
  margin: 5px 0;
}
</style>
